import { SearchTerm } from "./SearchTerm";

const BuildingSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "buildingName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    }
];

export default BuildingSearch;
